// import { useContext } from 'react';
import { MAX_VISIBLE_PURCHASE_MOTIONS_PA } from 'pricing-pages-ui/constants/MaxVisiblePurchaseMotions';
import { APP } from 'pricing-pages-ui/constants/tracking/App';
import { SCREENS } from 'pricing-pages-ui/constants/tracking/Locations';
import { activeCurrencySelector } from 'pricing-pages-ui/selectors/CurrencySelectors';
import { productBasedOfferIdsWithMandatorySkuSelector } from 'pricing-pages-ui/selectors/ProductBasedOffersSelectors';
import { checkoutProductConfigurationsSelector, productVersionConfigsWithUnitsSelector } from 'pricing-pages-ui/selectors/ProductConfigsSelectors';
import { hasHigherProductLevelInProductInventorySelector, hasProductVersionInProductInventorySelector } from 'pricing-pages-ui/selectors/ProductInventorySelectors';
import { highlightedSkuIdsSelector, productForSkuIdSelector, upgradeProductSelector } from 'pricing-pages-ui/selectors/ProductsSelectors'; // import { IsMobileContext } from 'pricing-pages-unified-ui/components/product-pages/mobileUtils';

import { purchaseMotionsSelector } from 'pricing-pages-ui/selectors/PurchaseMotionSelectors';
import { useSelector } from 'react-redux';
const buttonUses = {
  primaryButtonUse: 'primary',
  secondaryButtonUse: 'secondary'
}; // Common props that are used for merch card AuthedCTAs, and the loading state buttons

export const useMerchCardAuthedCTAsProps = ({
  additionalUnitQuantity,
  skuId,
  containterStyle = {},
  trackingSource
}) => {
  const isMobile = false; // FIXME: useContext(IsMobileContext);

  const {
    productLevel,
    productLine
  } = useSelector(state => productForSkuIdSelector(state, {
    skuId
  }) || {});
  const apiName = useSelector(state => {
    const product = productForSkuIdSelector(state, {
      skuId
    });
    return product && product.apiName;
  });
  const purchaseMotions = useSelector(state => purchaseMotionsSelector(state, {
    skuId
  })); // Default to 1 because we show a disabled button for 0 purchase motions

  const numPurchaseMotions = Math.min(purchaseMotions.length, MAX_VISIBLE_PURCHASE_MOTIONS_PA(productLine)) || 1;
  const maxPurchaseMotionsOnPage = useSelector(state => {
    const highlightedSkuIds = highlightedSkuIdsSelector(state, {
      productLine
    });
    return highlightedSkuIds.reduce((currentMax, tempSkuId) => {
      const length = purchaseMotionsSelector(state, {
        skuId: tempSkuId
      }).length;
      return Math.max(currentMax, Math.min(length, MAX_VISIBLE_PURCHASE_MOTIONS_PA(productLine)));
    }, 0);
  });
  let updatedStyled = containterStyle;

  if (isMobile) {
    updatedStyled = Object.assign({}, containterStyle, {
      minHeight: 'initial'
    });
  }

  const upgradeProduct = useSelector(state => upgradeProductSelector(state, {
    skuIds: [skuId]
  }));
  const upgradeData = {
    app: APP,
    screen: SCREENS.PRODUCTS_PLANS,
    uniqueId: `${trackingSource}-${upgradeProduct}`,
    upgradeProduct
  };
  const productConfigurations = useSelector(state => checkoutProductConfigurationsSelector(state, {
    productConfigurations: productVersionConfigsWithUnitsSelector(state, {
      skuId,
      additionalUnitQuantity
    }),
    subtractOwnedUnitsIfBuyingNoAdditional: true
  }));
  return Object.assign({
    containterStyle: updatedStyled,
    purchaseMotions,
    upgradeData,
    productBasedOffers: useSelector(state => productBasedOfferIdsWithMandatorySkuSelector(state, {
      skuIds: [skuId]
    })),
    activeCurrencyCode: useSelector(activeCurrencySelector),
    productConfigurations,
    ownsProduct: useSelector(state => hasProductVersionInProductInventorySelector(state, {
      skuId
    })),
    hasHigherTieredProduct: useSelector(state => hasHigherProductLevelInProductInventorySelector(state, {
      productLevel,
      productLine
    })),
    trackingSource,
    maxPurchaseMotionsOnPage,
    // used for loading state only
    numPurchaseMotions,
    // used for loading state only
    fallbackSeleniumIdentifier: apiName
  }, buttonUses);
};